@if (prop) {
  <section [class]="smallCard ? 'property-card small-card' : 'property-card'">
    <a [routerLink]="routerLink" class="link" appTooltip="Voir les détails du bien">
      <!-- left -->
      <div id="img">
        @if (mainPhoto) {
          <img [src]="mainPhoto" [alt]="(prop || propSummary)?.name" />
        }
      </div>
      <!-- right -->
      <div class="right">
        <div id="icons">
          <app-certification-badge
            [prop]="prop"
            [size]="certifBadgeSize"
            [class.separator]="prop.certified"
          ></app-certification-badge>
          <ul class="row-list">
            @if (propertyHelper.isInCondo(prop)) {
              <li>
                <mat-icon
                  color="accent"
                  appTooltip="Fait partie d'une copropriété"
                  aria-label="Fait partie d'une copropriété"
                  class="small-icon"
                  >{{ condoImageName }}</mat-icon
                >
              </li>
            }
            @if (!userHelper.isPropertyOwner(prop) && userHelper.canUpdateProperty(prop)) {
              <li>
                <mat-icon
                  color="accent"
                  appTooltip="Droits d'accès en délégation sur le bien"
                  aria-label="Droits d'accès en délégation sur le bien"
                  class="small-icon"
                  >vpn_key</mat-icon
                >
              </li>
            }
            <li>
              <mat-icon color="accent" class="small-icon" [appTooltip]="'enum.PropertyType.' + prop.type | translate">{{
                badgeImageName
              }}</mat-icon>
            </li>
          </ul>
        </div>
        @if (prop.demo) {
          <div class="banner demo">
            <span>DEMO</span>
          </div>
        }
        @if (isOnSelling) {
          <div class="banner selling">
            <span>{{ 'enum.SellingStatus.' + sellingStatus | translate }}</span>
          </div>
        }
        <header id="content">
          <h1>
            @if (showOwnerName) {
              {{ ownerName }}
            } @else {
              {{ propName }}
            }
          </h1>
          <p class="subtitle">{{ 'enum.PropertyType.' + prop.type | translate }}</p>
          @if (isOnSelling) {
            <p class="price">{{ price | currency: 'EUR' : 'symbol' : '1.0' }}</p>
          }
        </header>
        @if (showAddress && prop.address) {
          <div id="footer">
            <mat-icon class="place">location_on</mat-icon>
            @if (prop.address) {
              <address>
                @for (item of displayAddress; track item) {
                  <p>{{ item }}</p>
                }
              </address>
            }
          </div>
        }
      </div>
    </a>
    @if (showFavorite) {
      <div class="favorite">
        <a [appTooltip]="isFavorite ? 'Supprimer des favoris' : 'Ajouter au favoris'" (click)="toogleFavorite()">
          <mat-icon color="primary">{{ isFavorite ? 'favorite' : 'favorite_border' }}</mat-icon>
        </a>
      </div>
    }
  </section>
} @else {
  <div class="p-5 d-flex justify-content-center">
    <mat-icon>
      <mat-spinner diameter="20"> </mat-spinner>
    </mat-icon>
  </div>
}
<!--<section *ngIf="showMapLink && prop.location" class="mapLink">
    <span class="w-100 text-center">Gps: {{ prop.location?.latitude }}, {{ prop.location?.longitude }}</span>
    <span class="spacer"></span>
    <a [href]="externalMapLink" appTooltip="Voir sur Maps" target="_blank">
      <mat-icon color="primary">map</mat-icon>
    </a>
  </section>-->
